const SignInSignUpTypes = {
    SIGN_IN_SESSION: 'SIGN_IN_SESSION',
};

export default SignInSignUpTypes;
